// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/components/double-opt-dialog/double-opt-dialog.component.less
// module id = 244
// module chunks = 0